export class DateHelper {
    public static DateToString(inputDate: Date | undefined) : string | undefined {
        if(inputDate == undefined) {
            return undefined;
        }

        var dateString = `${('0' + inputDate.getDate()).slice(-2)}-${('0' + (inputDate.getMonth()+1)).slice(-2)}-${inputDate.getFullYear()}`;

        return `${('0' + inputDate.getDate()).slice(-2)}-${('0' + (inputDate.getMonth()+1)).slice(-2)}-${inputDate.getFullYear()}`;
    }
}